import { Divider, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import React, { memo } from "react";
import { useSelector } from "react-redux";
import { View, Text } from "../../../../components/Base";
import { OVERVIEW } from "../../../../constants/strings";
import useClick from "../../../../hooks/useClick";
import { getSectionName } from "../../../../store/selectors/sections";
import palette from "../../../styles/palette";
import StatsInfoRows from "./StatsInfoRows";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    background: palette.slate,
    padding: "0.75rem",
  },
  active: {
    background: palette.darkGreen,
  },
  row: {
    display: "flex",
    flexDirection: "row",
  },
  overview: {
    color: palette.sunburst,
  },
  sectionName: {
    color: palette.typography.white.solid,
  },
  divider: {
    background: palette.typography.white.medium,
    margin: "0 0.188rem 0.313rem 0",
  },
  label: {
    flex: 0.4,
  },
}));

const SectionOverview = ({
  onDoubleClick = () => {},
  onClick = () => {},
  route,
  active,
}) => {
  const styles = useStyles();
  const click = useClick(onClick, onDoubleClick);

  const sectionName = useSelector((state) =>
    getSectionName(state, route.sectionCode)
  );

  return (
    <View
      onClick={click}
      className={clsx(styles.container, active && styles.active)}
    >
      <View className={styles.row}>
        <Text className={styles.overview} data-testid="section-overview">
          {OVERVIEW} -
        </Text>
        &nbsp;
        <Text className={styles.sectionName} data-testid="section-name">
          {sectionName}
        </Text>
      </View>
      <Divider className={styles.divider} />
      <StatsInfoRows route={route} labelStyle={styles.label} />
    </View>
  );
};

export default memo(SectionOverview);
